import React, { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { gameConfigStore, userInfoStore } from '@pascal/pascal-core/shared/core/store';
import { freeBetStore, notificationStore, useTranslation } from '@pascal/pascal-core';
import { gameStore } from '../../store/gameStore';
import { doBetStore } from '../../store/doBetStore';
import { autoBetStore } from '../../store/autoBetStore';
import { turboGameService } from '../../services/TurboGameService';
import { INFINITY_AUTO_BET } from '../../enums/constants';
import { betResponseCodeByName } from '../../enums/betResponseCode';

export const DealSection = observer(() => {
  const { setDouble, setHalve, selectedAmount } = doBetStore;
  const { autoBetCount, isPlay, resetAutoBet } = autoBetStore;
  const { balance } = userInfoStore;
  const { limits } = gameConfigStore;
  const { activeFreeBet } = freeBetStore;
  const { isBetsClosed } = gameStore;
  const t = useTranslation();

  const handleDeal = useCallback(() => {
    if (selectedAmount > balance && !activeFreeBet.id) {
      notificationStore.setNotificationType(betResponseCodeByName.NotEnoughBalance);
      setTimeout(() => notificationStore.setNotificationType(null), 1000);
    }
    if (isPlay) {
      resetAutoBet();
    } else if (!isBetsClosed) {
      turboGameService.sendBet();
    }
  }, [selectedAmount, balance, activeFreeBet.id, isPlay, isBetsClosed, resetAutoBet]);

  return (
    <div className='tb-g-b-btn-m'>
      <div
        className={`tb-g-b-small-btn-wrp ${
          isBetsClosed || selectedAmount === limits?.minBet || activeFreeBet.id ? 'passive' : ''
        }`}
        onClick={setHalve}
      >
        <p className='tb-g-b-small-btn-number'>1/2</p>
      </div>
      <div className={`tb-g-b-big-btn-wrp ${isPlay ? 'stop' : ''}`} onClick={handleDeal}>
        <div className='tb-g-b-big-btn-inside '>
          <div className='tb-g-b-big-btn-holder'>
            {!!autoBetCount && (
              <div className='stop-btn-block-inner'>
                <p className='stop-btn-block-inner-number'>
                  {autoBetCount === INFINITY_AUTO_BET ? '∞' : autoBetCount}
                </p>
              </div>
            )}
            <button className='tb-g-b-big-btn '>
              <p className='tb-g-b-big-btn-txt'>{isPlay ? t('STOP') : t('DEAL')}</p>
            </button>
          </div>
        </div>
      </div>
      <div
        className={`tb-g-b-small-btn-wrp ${
          isBetsClosed ||
          selectedAmount === limits?.maxBet ||
          balance < selectedAmount * 2 ||
          activeFreeBet.id
            ? 'passive'
            : ''
        }`}
        onClick={setDouble}
      >
        <p className='tb-g-b-small-btn-number'>x2</p>
      </div>
    </div>
  );
});
